// extracted by mini-css-extract-plugin
export var author = "responsive-table-module--author--22d03";
export var category = "responsive-table-module--category--a447f";
export var hasScrolled = "responsive-table-module--hasScrolled--669ba";
export var headline = "responsive-table-module--headline--1c3a2";
export var headlinePost = "responsive-table-module--headline-post--32474";
export var paragraph = "responsive-table-module--paragraph--b74f6";
export var scrollable = "responsive-table-module--scrollable--7d88e";
export var tableContainer = "responsive-table-module--tableContainer--bd5e7";
export var tableWrapper = "responsive-table-module--tableWrapper--c1c59";